<template>
	<div class="containerMain">
		<title-bar :topTitle="true" topTitleText="Colegios"/>
		<div class="col inner" v-if="schools">
			<div class="col between innerRubric sd">
				<b-table responsive class="category all" striped hover :items="schools" :fields="tableFields">
					<template slot="lastDate" slot-scope="item">
						{{item.value ? item.value == 'Sin visitas' ? item.value : getHumanDate(item.value) : ''}}
					</template>
					<template slot="actions" slot-scope="item">
						<b-button size="lg" class="more" @click="goToRoute(item)">
							Ver más
						</b-button>
					</template>
				</b-table>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	data () {
		return {
			tableFields: {
				name: {
					label: 'Colegio',
					sortable: true
				},
				lastDate: {
					label: 'Última visita',
					sortable: true
				},
				visitClosures: {
					label: 'Cierres',
					sortable: true
				},
				trainings: {
					label: 'Capacitación',
					sortable: true
				},
				issues: {
					label: 'Incidencias',
					sortable: true
				},
				diagnoses: {
					label: 'Diagnóstico',
					sortable: true
				},
				evaluations: {
					label: 'Evaluaciones',
					sortable: true
				},
				actions: {
					label: '',
					sortable: false
				}
			}
		};
	},
	computed: {
		schools () {
			console.log(this.$store.state.admin.schools);
			if (!this.$store.state.admin.schools) return null;
			return this.$store.state.admin.schools.map((school) => {
				school.lastDate = school.synthesisSummary[0].lastDate ? school.synthesisSummary[0].lastDate : 'Sin visitas';
				school.visitClosures = school.synthesisSummary.find((synthesis) => (synthesis.code == 'visitClosure'));
				school.visitClosures = school.visitClosures ? school.visitClosures.count : 0;
				school.trainings = school.synthesisSummary.find((synthesis) => (synthesis.code == 'training'));
				school.trainings = school.trainings ? school.trainings.count : 0;
				school.issues = school.synthesisSummary.find((synthesis) => (synthesis.code == 'issue'));
				school.issues = school.issues ? school.issues.count : 0;
				school.diagnoses = school.synthesisSummary.find((synthesis) => (synthesis.code == 'currentDiagnosis'));
				school.diagnoses = school.diagnoses ? school.diagnoses.count : 0;
				school.evaluations = school.synthesisSummary.find((synthesis) => (synthesis.code == 'evaluation'));
				school.evaluations = school.evaluations ? school.evaluations.count : 0;
				return school;
			});
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		},
		goToRoute (item) {
			this.$store.dispatch('setSchoolMenu', {
				schoolId: item.item.schoolId,
				name: item.item.name
			});
			this.$router.push(`/coaching/admin/schools/${item.item.schoolId}/syntheses`);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/AdminSchools.vue